import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { DirectOrderDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { DirectOrderDto } from 'src/app/shared/models/direct-order/direct-order-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class DirectOrderWorkItem extends WorkItem<DirectOrderDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'DirectOrderWorkItem';
  }
  get database(): string {
    return DirectOrderDB;
  }

  get chunkSize(): number {
    return 250;
  }
}
